import { HttpEvent, HttpInterceptorFn } from '@angular/common/http';
import { formatOutgoingDate } from '@core/misc/misc.utils';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';

/**
 * Serializes `Date` objects and ISO date strings found in outgoing request bodies
 * targeting the Nugios API. Multipart uploads (`FormData`) and non-object bodies
 * are forwarded unchanged.
 */
export const DateInterceptor: HttpInterceptorFn = (request, next): Observable<HttpEvent<unknown>> => {
  if (!request.url.includes(environment.urls.api)) return next(request);
  if (request.body instanceof FormData) return next(request);
  if (typeof request.body !== 'object' && !Array.isArray(request.body)) return next(request);

  const formattedBody = formatOutgoingDate(JSON.parse(JSON.stringify(request.body)) as Record<string, unknown>);
  return next(request.clone({ body: formattedBody }));
};
